import { render, staticRenderFns } from "./outboundRecord.vue?vue&type=template&id=2da822c2"
import script from "./outboundRecord.vue?vue&type=script&lang=js"
export * from "./outboundRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports